import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="work-types--form"
export default class extends Controller {
  static targets = ["form", "wages", "wageTemplate"];

  new() {
    document.querySelectorAll("#work-type-list table tr.selected")
            .forEach(e => e.classList.remove("selected"))
  }

  addWage(event) {
    event.preventDefault();

    const content = this.wageTemplateTarget.innerHTML
      .replace(/NEW_RECORD/g, Date.now())

    this.wagesTarget.insertAdjacentHTML("beforeend", content)
  }

  removeWage(event) {
    const row = event.target.closest("tr")

    // If existing record → mark for destruction
    const destroyInput = row.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
